import { type FirebaseApp, initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { initAnalytics } from "./analytics";

export interface Environment {
  environment: string;
  adminEmails?: string[];
  apiRoots: {
    management: string;
    integration: string;
    search: string;
  };
  firebaseConfig: {
    apiKey: string;
    authDomain: string;
    projectId: string;
    storageBucket: string;
    messagingSenderId: string;
    appId: string;
    measurementId: string;
  };
  legals: {
    termsOfService: string;
    privacyPolicy: string;
  };
  analytics: {
    clarityProjectId: string;
  };
  sharepointAppClientId: string;
  googleAppClientId: string;
  googleOAuth2ClientId: string;
}

export const environment = new Promise<Environment>(async (resolve, reject) => {
  let envFile = "/env.json";
  if (import.meta.env.MODE === "development") {
    console.info("VITE Development mode detected, using local environment variables");
    envFile = "/env.local.json";
  } else if (window.location.hostname === "localhost") {
    console.info("Running on localhost, using local environment variables");
    envFile = "/env.local.json";
  }

  const response = await fetch(envFile);
  const data = await response.json();
  resolve(data);
});

export const sessionId = "sid-" + Date.now() + "-" + Math.random().toString(36).substring(2, 9);

export const firebaseApp = new Promise<FirebaseApp>(async (resolve, reject) => {
  const env = await environment;
  const firebaseApp = await initializeApp(env.firebaseConfig);
  resolve(firebaseApp);
});

export const envLoaded = new Promise<void>(async (resolve, reject) => {
  const fb = await firebaseApp;
  // Initialise both auth & firestore before completion, as we always need these
  await getAuth(fb);
  await getFirestore(fb);
  await initAnalytics();
  resolve();
});
